var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_4531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0006 8.33337C26.959 8.33337 8.33398 26.9584 8.33398 50C8.33398 73.0417 26.959 91.6667 50.0006 91.6667C73.0423 91.6667 91.6673 73.0417 91.6673 50C91.6673 26.9584 73.0423 8.33337 50.0006 8.33337ZM70.834 64.9584L64.959 70.8334L50.0006 55.875L35.0423 70.8334L29.1673 64.9584L44.1256 50L29.1673 35.0417L35.0423 29.1667L50.0006 44.125L64.959 29.1667L70.834 35.0417L55.8756 50L70.834 64.9584Z",
    fill: "#FF3B6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_4531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.fe0045cde2a1fd50d59b75faab92a8fe.svg";
export { ForwardRef as ReactComponent };